import "jquery-validation";

((($:JQueryStatic) => {

    $.validator.setDefaults({ignore:""});

    $.validator.addMethod("daterange", function (value, element, arg) {
        if (this.optional(element)) {
            return true;
        }

        var startDate = Date.parseExact(arg[0], Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS),
            endDate = Date.parseExact(arg[1], Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);

        try {
            var enteredDate = Date.parseExact(value, Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);
            if (isNaN(enteredDate)) {
                return false;
            }

            return ((startDate <= enteredDate) && (enteredDate <= endDate));
        }
        catch (error) {
            return true; //Can't parse date? Don't run this validation
        }

    });

    $.validator.addMethod("datemin", function (value, element, arg) {
        if (this.optional(element)) {
            return true;
        }

        var startDate = Date.parseExact(arg, Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);

        try {
            var enteredDate = Date.parseExact(value, Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);
            if (isNaN(enteredDate)) {
                return false;
            }

            return (startDate <= enteredDate);
        }
        catch (error) {
            return true; //Can't parse date? Don't run this validation
        }

    });

    $.validator.addMethod("datemax", function (value, element, arg) {
        if (this.optional(element)) {
            return true;
        }

        var endDate = Date.parseExact(arg, Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);

        try {
            var enteredDate = Date.parseExact(value, Ahb.NZ_DATE_FORMAT_PARSE_DATE_JS);
            if (isNaN(enteredDate)) {
                return false;
            }

            return (enteredDate <= endDate);
        }
        catch (error) {
            return true; //Can't parse date? Don't run this validation
        }

    });
    

    $.validator.addMethod("digitsOrSpaces", function (value, element) {
        return this.optional(element) || /^[\d| ]+$/.test(value);
    });


    // See http://ajax.aspnetcdn.com/ajax/jquery.validate/1.9/additional-methods.js

    /**
    * Return true, if the value is a valid date, also making this formal check dd/mm/yyyy.
    *
    * @example jQuery.validator.methods.date("01/01/1900")
    * @result true
    *
    * @example jQuery.validator.methods.date("01/13/1990")
    * @result false
    *
    * @example jQuery.validator.methods.date("01.01.1900")
    * @result false
    *
    * @example <input name="pippo" class="{dateITA:true}" />
    * @desc Declares an optional input element whose value must be a valid date.
    *
    * @name jQuery.validator.methods.dateITA
    * @type Boolean
    * @cat Plugins/Validate/Methods
    */
    $.validator.addMethod(
        "dateITA",
        function (value, element) {

            var check:boolean;
            const re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

            if (re.test(value)) {
                var adata = value.split("/");
                var gg = parseInt(adata[0], 10);
                var mm = parseInt(adata[1], 10);
                var aaaa = parseInt(adata[2], 10);
                var xdata = new Date(aaaa, mm - 1, gg);
                if ((xdata.getFullYear() === aaaa) && (xdata.getMonth() === mm - 1) && (xdata.getDate() === gg))
                    check = true;
                else
                    check = false;
            } else
                check = false;
            return this.optional(element) || check;
        });

    $.validator.addMethod("integer", function (value, element) {
        return this.optional(element) || /^-?\d+$/.test(value);
    });

})(jQuery));




// WEBPACK FOOTER //
// ./ScriptsTS/ValidationMethods.ts